<div>
  <ngx-loading [show]="isAuth0CallbackLoading"></ngx-loading>
</div>
